import { PoliciesTypes } from '../services/helpers/client-area-helper.service';
import { checkPolicyHasDetail, Policy, PolicyBaseType } from './policy';

export interface ProductCard {
  img: string;
  avatar?: string;
  policyType?: PoliciesTypes;
  cardTypeString?: string;
  cardTypeStringRo?: string;
  title: string;
  endTitle?: string;
  subtitle?: string;
  firstDetail?: string;
  secondDetail?: string;
  chipText?: string;
  isCategory: boolean;
  hasAlert: boolean;
  policy?: Policy;
  belongsToLifeCycle?: boolean;
  policies?: Policy[];
  lifeCyclePolicyType?: LifeCyclePolicyType;
  disabled?: boolean;
}

export enum LifeCyclePolicyType {
  FUTURE_PROGRAM = 'CVID',
  EPSV = 'CVIE',
}

export interface ClientAreaCardLocalConfig {
  cardType: string;
  icon: string;
  errorText: string;
}

export interface ClientAreaCardRemoteConfig {
  cardType: string;
  order: number;
  policyCardName: string;
  groupingName: string;
  minNumberSearchBarPolicies: number;
  ro: {
    entityCode: string;
    groupingCode: string;
  };
  policyBaseTypes: PolicyBaseType[];
}

export interface ClientAreaCardConfig {
  cardType: string;
  icon: string;
  order: number;
  policyCardName: string;
  groupingName: string;
  minNumberSearchBarPolicies: number;
  errorText: string;
  ro: {
    entityCode: string;
    groupingCode: string;
  };
  policyBaseTypes: PolicyBaseType[];
}

export interface ClientAreaConfigurableCard {
  cardConfig: ClientAreaCardConfig;
  groupedPoliciesLists?: ClientAreaPoliciesGroup;
}

export interface ClientAreaErrorCard {
  cardType: string;
  icon: string;
  order: number;
  groupingName: string;
  errorText: string;
  isPartialError: boolean;
}

export interface ClientAreaVisibleCard {
  cardConfig: ClientAreaCardConfig;
  groupedCard?: ClientAreaGroupedCard;
  policyCard?: ClientAreaPolicyCard;
  resume?: string;
}

export interface ClientAreaGroupedCard {
  groupedPoliciesLists: ClientAreaPoliciesGroup;
  chipText: string;
  hasAlert: boolean;
}

export interface ClientAreaPolicyCard {
  policy: Policy;
  hasAlert: boolean;
  disabled?: boolean;
}

export interface ClientAreaPoliciesGroup {
  policyBaseEntries: PolicyBaseEntry[];
  hasErrors?: boolean;
}

export interface PolicyBaseEntry {
  policyBaseType: PolicyBaseType;
  policiesList?: Policy[];
  policiesListError?: boolean;
  policiesListErrorDetail?: { type: PolicyBaseType; errorDetail: string };
}

export enum PolicyTypesBusinesses {
  CAR = 'CAR',
  HOME = 'HOME',
  OTHER = 'OTHER',
  SAVING = 'SAVING',
  SPORT_BOAT = 'SPORT_BOAT',
  MACHINERY_EQUIPMENT = 'MACHINERY_EQUIPMENT',
  BUSINESS = 'BUSINESS',
  PEOPLE = 'PEOPLE',
  CIVIL_LIABILITY = 'CIVIL_LIABILITY'
}

// TODO: Add icons and error texts for new types to assets
export const CARDS_LOCAL_CONFIG_BUSINESSES: ClientAreaCardLocalConfig[] = [
  {
    cardType: PolicyTypesBusinesses.CAR,
    icon: 'assets/images/products/car.svg',
    errorText: 'CLIENT_AREA.CA_HOME.CONFIGURABLE_CARDS.NO_POLICIES.CAR.TEXT'
  },
  {
    cardType: PolicyTypesBusinesses.HOME,
    icon: 'assets/images/products/home.svg',
    errorText: 'CLIENT_AREA.CA_HOME.CONFIGURABLE_CARDS.NO_POLICIES.HOME.TEXT'
  },
  {
    cardType: PolicyTypesBusinesses.OTHER,
    icon: 'assets/images/products/other.svg',
    errorText: 'CLIENT_AREA.CA_HOME.CONFIGURABLE_CARDS.NO_POLICIES.OTHER.TEXT'
  },
  {
    cardType: PolicyTypesBusinesses.SAVING,
    icon: 'assets/images/products/saving.svg',
    errorText: 'CLIENT_AREA.CA_HOME.CONFIGURABLE_CARDS.NO_POLICIES.SAVING.TEXT'
  },
  {
    cardType: PolicyTypesBusinesses.SPORT_BOAT,
    icon: 'assets/images/products/sport_boat.svg',
    errorText: 'CLIENT_AREA.CA_HOME.CONFIGURABLE_CARDS.NO_POLICIES.SPORT_BOAT.TEXT'
  },
  {
    cardType: PolicyTypesBusinesses.MACHINERY_EQUIPMENT,
    icon: 'assets/images/products/machinery_equipment.svg',
    errorText: 'CLIENT_AREA.CA_HOME.CONFIGURABLE_CARDS.NO_POLICIES.MACHINERY_EQUIPMENT.TEXT'
  },
  {
    cardType: PolicyTypesBusinesses.BUSINESS,
    icon: 'assets/images/products/business.svg',
    errorText: 'CLIENT_AREA.CA_HOME.CONFIGURABLE_CARDS.NO_POLICIES.BUSINESS.TEXT'
  },
  {
    cardType: PolicyTypesBusinesses.PEOPLE,
    icon: 'assets/images/products/people.svg',
    errorText: 'CLIENT_AREA.CA_HOME.CONFIGURABLE_CARDS.NO_POLICIES.PEOPLE.TEXT'
  },
  {
    cardType: PolicyTypesBusinesses.CIVIL_LIABILITY,
    icon: 'assets/images/products/civil_liability.svg',
    errorText: 'CLIENT_AREA.CA_HOME.CONFIGURABLE_CARDS.NO_POLICIES.CIVIL_LIABILITY.TEXT'
  }
];

export interface ProductsList {
  icon: string;
  title: string;
  url: string;
}

export enum ProductIcons {
  'car' = 'car',
  'scooter' = 'scooter',
  'home' = 'home',
  'health' = 'health',
  'dental' = 'dental',
  'travels' = 'travels',
  'compensation' = 'compensation',
  'essential-compensation' = 'essential-compensation',
  'life' = 'life',
  'saving' = 'saving',
  'death' = 'death',
  'foreigners-death' = 'foreigners-death',
  'accidents' = 'accidents',
  'pets' = 'pets',
  'legal-defense' = 'legal-defense',
  'bike' = 'bike',
  'investment' = 'investment'
}

export function processDisabledClientAreaPolicyCard(card: ClientAreaPolicyCard) {
  if (!card) { return; }
  if (!card.policy) {
    card.disabled = true;
  } else {
    card.disabled = !checkPolicyHasDetail(card.policy);
  }
}

export function processDisabledCards(cards: ProductCard[]) {
  if (cards?.length > 0) {
    cards.forEach(c =>{
      c.disabled = !checkPolicyHasDetail(c.policy);
    });
  }
}

